/*!
 * @hagbardpaulson/spatial-beta v0.1.9058
 * Made with <3 2021
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["@hagbardpaulsonSpatialBeta"] = factory(require("vue"));
	else
		root["@hagbardpaulsonSpatialBeta"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newComponent) {
    var defaults = {
        props: {
            spTheme: null
        },
        computed: {
            $mdActiveTheme: function $mdActiveTheme() {
                var enabled = _SpTheme2.default.enabled,
                    getThemeName = _SpTheme2.default.getThemeName,
                    getAncestorTheme = _SpTheme2.default.getAncestorTheme;


                if (enabled && this.spTheme !== false) {
                    return getThemeName(this.spTheme || getAncestorTheme(this));
                }

                return null;
            }
        }
    };

    return (0, _deepmerge2.default)(defaults, newComponent);
};

var _SpTheme = __webpack_require__(4);

var _SpTheme2 = _interopRequireDefault(_SpTheme);

var _deepmerge = __webpack_require__(31);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(25);

var _MdReactive = __webpack_require__(26);

var _MdReactive2 = _interopRequireDefault(_MdReactive);

var _SpTheme = __webpack_require__(4);

var _SpTheme2 = _interopRequireDefault(_SpTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
    var material = new _MdReactive2.default({
        theming: {}
    });

    Object.defineProperties(material.theming, {
        metaColors: {
            get: function get() {
                return _SpTheme2.default.metaColors;
            },
            set: function set(metaColors) {
                _SpTheme2.default.metaColors = metaColors;
            }
        },
        theme: {
            get: function get() {
                return _SpTheme2.default.theme;
            },
            set: function set(theme) {
                _SpTheme2.default.theme = theme;
            }
        },
        enabled: {
            get: function get() {
                return _SpTheme2.default.enabled;
            },
            set: function set(enabled) {
                _SpTheme2.default.enabled = enabled;
            }
        }
    });

    return material;
};

exports.default = function (Vue) {
    if (!Vue.material) {
        Vue.material = init();
        Vue.prototype.$material = Vue.material;
    }
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msColor = null;
var themeColor = null;
var maskIcon = null;

exports.default = new _vue2.default({
    data: function data() {
        return {
            prefix: "sp-theme-",
            theme: "default",
            enabled: true,
            metaColors: false
        };
    },
    computed: {
        themeTarget: function themeTarget() {
            if (!this.$isServer) {
                return document.documentElement;
            }

            return false;
        },
        fullThemeName: function fullThemeName() {
            return this.getThemeName();
        }
    },
    watch: {
        enabled: {
            immediate: true,
            handler: function handler() {
                var fullThemeName = this.fullThemeName,
                    themeTarget = this.themeTarget,
                    enabled = this.enabled;


                if (themeTarget) {
                    if (enabled) {
                        themeTarget.classList.add(fullThemeName);
                        this.metaColors && this.setHtmlMetaColors(fullThemeName);
                    } else {
                        themeTarget.classList.remove(fullThemeName);
                        this.metaColors && this.setHtmlMetaColors();
                    }
                }
            }
        },
        theme: function theme(newTheme, oldTheme) {
            var getThemeName = this.getThemeName,
                themeTarget = this.themeTarget;


            newTheme = getThemeName(newTheme);

            themeTarget.classList.remove(getThemeName(oldTheme));
            themeTarget.classList.add(newTheme);

            if (this.metaColors) {
                this.setHtmlMetaColors(newTheme);
            }
        },
        metaColors: function metaColors(meta) {
            if (meta) {
                this.setHtmlMetaColors(this.fullThemeName);
            } else {
                this.setHtmlMetaColors();
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        msColor = document.querySelector("[name=\"msapplication-TileColor\"]");
        themeColor = document.querySelector("[name=\"theme-color\"]");
        maskIcon = document.querySelector("[rel=\"mask-icon\"]");

        if (this.enabled && this.metaColors) {
            window.addEventListener("load", function () {
                _this.setHtmlMetaColors(_this.fullThemeName);
            });
        }
    },

    methods: {
        getAncestorTheme: function getAncestorTheme(component) {
            var _this2 = this;

            if (component) {
                var currentTheme = component.spTheme;
                var getParentThemeName = function getParentThemeName(parent) {
                    if (parent) {
                        var spTheme = parent.spTheme,
                            $parent = parent.$parent;


                        if (spTheme && spTheme !== currentTheme) {
                            return spTheme;
                        }

                        return getParentThemeName($parent);
                    }

                    return _this2.theme;
                };

                return getParentThemeName(component.$parent);
            }

            return null;
        },
        getThemeName: function getThemeName(theme) {
            var themeName = theme || this.theme;

            return this.prefix + themeName;
        },
        setMicrosoftColors: function setMicrosoftColors(primaryColor) {
            if (msColor) {
                msColor.setAttribute("content", primaryColor);
            }
        },
        setThemeColors: function setThemeColors(primaryColor) {
            if (themeColor) {
                themeColor.setAttribute("content", primaryColor);
            }
        },
        setMaskColors: function setMaskColors(primaryColor) {
            if (maskIcon) {
                maskIcon.setAttribute("color", primaryColor);
            }
        },
        setHtmlMetaColors: function setHtmlMetaColors(themeName) {
            var primaryColor = "#fff";

            if (themeName) {
                var computedStyle = window.getComputedStyle(document.documentElement);

                primaryColor = computedStyle.getPropertyValue("--" + themeName + "-primary");
            }

            if (primaryColor) {
                this.setMicrosoftColors(primaryColor);
                this.setThemeColors(primaryColor);
                this.setMaskColors(primaryColor);
            }
        }
    }
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpButton",
    methods: {
        triggerClick: function triggerClick(e) {
            if (this.isLoading) {
                return;
            }
            this.$emit("click", e);
        }
    }
}); //
//
//
//
//
//

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "SpInputField",
    props: ["id", "label", "validationMessage"]
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpInputText",
    // props: ["id", "value", "label", "placeholder", "prefix", "maxlength"],
    props: {
        id: String,
        type: {
            type: String,
            default: "text"
        },
        value: String,
        label: String,
        placeholder: {
            type: String,
            default: null
        },
        prefix: {
            type: String,
            default: null
        },
        suffix: {
            type: String,
            default: null
        },
        maxlength: String,
        // validation
        validate: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        isValid: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            buffer: this.value,
            isNull: false,
            validationMessage: ""
        };
    },

    watch: {
        value: function value() {
            this.buffer = this.value;
        }
    },
    mounted: function mounted() {
        this.isNull = this.isEmptyOrSpaces(this.value);
    },

    methods: {
        keyDown: function keyDown(event) {
            this.$emit("keydown", event);
            if (event.keyCode === 13) {
                this.$emit("keydownenter", event);
            }
        },
        keyUp: function keyUp(event) {
            this.$emit("keyup", event);
            if (event.keyCode === 13) {
                this.$emit("keyupenter", event);
            }
        },
        blur: function blur(value) {
            this.$emit("blur", value);
            console.log(value);
            if (this.validate) {
                this.validateValue(value);
            }
        },
        updateValue: function updateValue(value) {
            this.$emit("input", value);
            this.isNull = this.isEmptyOrSpaces(value);
            if (this.validate) {
                this.validateValue(value);
            }
        },
        validateValue: function validateValue(value) {
            var valid = true;
            if (this.required) {
                if (this.isEmptyOrSpaces(value)) {
                    valid = false;
                    this.validationMessage = "Fyll i detta fält";
                }
            }
            if (this.type === "email") {
                if (!this.isValidEmail(value)) {
                    valid = false;
                    this.validationMessage = "Ange korrekt email";
                }
            }
            this.isValid = valid;
            if (valid) {
                this.validationMessageError = null;
            }
        },

        // validation
        isEmptyOrSpaces: function isEmptyOrSpaces(str) {
            return !str || str === null || str.match(/^ *$/) !== null;
        },
        isValidEmail: function isValidEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpInputTextarea",
    props: ["id", "value", "label", "placeholder", "maxlength", "autoheight"],
    data: function data() {
        return {
            buffer: this.value,
            isNull: false,
            isValid: true
        };
    },

    computed: {},
    watch: {
        value: function value() {
            this.buffer = this.value;
        },
        buffer: function buffer() {
            // if (this.autoheight === true) {
            //     this.$nextTick(() => {
            //         this.setHeight();
            //     });
            // }
        }
    },
    mounted: function mounted() {
        this.isNull = this.isEmptyOrSpaces(this.value);
        this.updateHeight();
    },

    methods: {
        updateValue: function updateValue(value) {
            this.$emit("input", value);
            this.isNull = this.isEmptyOrSpaces(value);
            console.log("update");
            this.updateHeight();
        },
        isEmptyOrSpaces: function isEmptyOrSpaces(str) {
            return !str || str === null || str.match(/^ *$/) !== null;
        },
        updateHeight: function updateHeight() {
            var _this = this;

            if (this.autoheight !== true) {
                return;
            }
            this.$nextTick(function () {
                _this.$refs.textarea.setAttribute("style", "height:" + _this.$refs.ghost.offsetHeight + "px"
                // ``,
                );
            });
        }
    }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpInputSelect",
    props: ["id", "value", "label", "items", "placeholder", "maxlength", "search"],
    data: function data() {
        return {
            val: this.value,
            selectedHtml: null,
            active: false,
            closeHandler: null,

            selectedItem: null,
            buffer: "",
            isNull: false,
            isValid: true,
            matchedItems: []
        };
    },

    computed: {
        isActive: function isActive() {
            return this.active;
            // return this.activeSelectId() === this.id;
        }
    },
    watch: {
        value: function value() {
            this.val = this.value;
            // this.selectItem(this.value);
            // this.buffer = this.value;
        },
        items: function items() {
            this.matchedItems = this.items;
        }
    },
    created: function created() {
        this.$on("selected", this.updateValue);
        this.updateValue(this.buffer);
        this.matchedItems = this.items;
        this.selectItem(this.value);
    },

    methods: {
        updateValue: function updateValue(value) {
            // this.$emit("input", value);
            this.isNull = this.isEmptyOrSpaces(value);
            this.matchItems(this.buffer);
        },
        matchItems: function matchItems(xx) {
            this.matchedItems = this.filterByValue(this.items, xx);
        },
        blur: function blur() {
            // const matchedItems = this.filterByValue(this.items, this.buffer);
            // console.log(matchedItems.length);
            // // check matched items, if not null set first match
            // if (matchedItems.length) {
            //     console.log(matchedItems[0]);
            //     this.selectItem(matchedItems[0].value);
            // }
        },
        isEmptyOrSpaces: function isEmptyOrSpaces(str) {
            return !str || str === null || str.match(/^ *$/) !== null;
        },
        toggle: function toggle() {
            var _this = this;

            if (this.active) {
                return;
            }

            if (this.closeHandler) {
                // remove Event Listeners
                document.removeEventListener("click", this.closeHandler);
                document.removeEventListener("touchstart", this.closeHandler);
                this.closeHandler = null;
            }
            if (this.active) {
                this.active = false;
                return;
            }

            this.active = true;

            // add Event Listeners
            document.addEventListener("click", this.closeHandler);
            document.addEventListener("touchstart", this.closeHandler);

            // Define Handler and cache it on the element
            var handler = function handler(he) {
                if (!_this.isChild(he.target, _this.$refs.input) && !_this.isChild(he.target, _this.$refs.dropdown)) {
                    _this.active = false;
                    _this.buffer = _this.selectedItem.header;
                    document.removeEventListener("click", _this.closeHandler);
                    document.removeEventListener("touchstart", _this.closeHandler);
                    _this.closeHandler = null;
                }
            };
            this.closeHandler = handler;

            // add Event Listeners
            setTimeout(function () {
                document.addEventListener("click", handler);
                document.addEventListener("touchstart", handler);
            }, 0);
        },
        isChild: function isChild(obj, parentObj) {
            while (obj !== undefined && obj != null && obj.tagName.toUpperCase() !== "BODY") {
                if (obj === parentObj) {
                    return true;
                }
                obj = obj.parentNode;
            }
            return false;
        },
        filterByValue: function filterByValue(array, string) {
            var newArray = array.filter(function (el) {
                return el.header.toLowerCase().includes(string.toLowerCase());
            });
            return newArray;
        },
        selectItem: function selectItem(value) {
            // console.log(value);
            var selectedItem = this.items.filter(function (obj) {
                return obj.value === value;
            })[0];
            this.buffer = selectedItem.header;
            this.selectedItem = selectedItem;
            this.$emit("input", selectedItem.value);
            this.active = false;
            this.matchItems("");
        }
    }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpMobileMenu",
    props: ["enabled"],
    methods: {
        checkIfHide: function checkIfHide(e) {
            if (e.target.classList.contains("sp-trigger-hide")) {
                this.$emit("hide");
            }
        }
    }
}); //
//
//
//
//
//

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpOverlay",
    props: ["enabled"],
    methods: {
        hide: function hide() {
            this.$emit("hide");
        }
    }
}); //
//
//
//

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpTreemenu",
    props: {
        id: null
    },
    created: function created() {
        // this.$on("selected", this.selected);
    }
}); //
//
//
//
//
//

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "SpTreemenuItem",
    props: ["value"],
    data: function data() {
        return {
            expanded: false
        };
    },

    computed: {
        hasSlotData: function hasSlotData() {
            return this.$slots.nested;
        }
    },
    methods: {
        select: function select(e) {
            this.$parent.$emit("selected", this.value);
            this.$emit("click", e);
            if (this.hasSlotData) {
                this.toggleExpand();
            }
        },
        toggleExpand: function toggleExpand() {
            this.expanded = !this.expanded;
            // this.expanded = true;
        }
    }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpCheckbox",
    props: ["label", "value"],
    data: function data() {
        return {
            checked: this.value
        };
    },

    methods: {
        onInput: function onInput() {
            this.checked = !this.checked;
            this.$emit("input", this.checked);
        }
    }
}); //
//
//
//
//
//
//

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpRadio",
    props: ["binding", "label", "data", "value"],
    methods: {
        onInput: function onInput() {
            this.$emit("input", this.data);
        }
    },
    created: function created() {
        this.$emit("input", this.data);
    }
}); //
//
//
//
//
//
//

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpModal",
    props: {
        id: null,
        header: {
            type: String,
            default: function _default() {
                return "false";
            }
        },
        enabled: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        width: {
            type: String,
            default: function _default() {
                return "450px";
            }
        },
        height: {
            type: String,
            default: function _default() {
                return "450px";
            }
        },
        error: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },
    computed: {
        currentPage: function currentPage() {
            return this.pages[this.pageIndex];
        }
    },
    watch: {
        enabled: function enabled(newVal) {
            var _this = this;

            if (newVal) {
                this.$emit("opened");
                this.pageIndex = 0;
                this.error = false;
                this.hide = false;
            } else if (!newVal) {
                this.$emit("closed");
                setTimeout(function () {
                    _this.hide = true;
                    console.log("hidden");
                }, 200);
            }
        }
    },
    data: function data() {
        return {
            hide: true,
            pages: [],
            pageIndex: 0
        };
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$slots.default.forEach(function (child) {
            if (child.componentOptions && child.componentOptions.tag === "sp-modal-page") {
                _this2.pages.push(child.componentOptions.propsData.name);
            }
        });
    },

    methods: {
        closeModal: function closeModal() {
            this.$emit("hide");
        },
        stepToIndex: function stepToIndex(index) {
            this.pageIndex = index;
        },
        stepToPrevious: function stepToPrevious() {
            var nextIndex = this.pageIndex - 1;
            if (nextIndex >= 0) {
                this.pageIndex = nextIndex;
            }
        },
        stepToNext: function stepToNext() {
            var nextIndex = this.pageIndex + 1;
            if (nextIndex < this.pages.length) {
                this.pageIndex = nextIndex;
            }
        }
    }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "SpModalPage",
    props: ["name", "scroll"],
    data: function data() {
        return {
            borderTopOpacity: 0
        };
    },

    computed: {
        visible: function visible() {
            return this.$parent.currentPage === this.name;
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var ref = this.$refs["sp-modal-page-content-" + this.name];
        ref.addEventListener("scroll", this.handleScroll);
        this.handleScroll();
    },
    destroyed: function destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },

    methods: {
        stepToPrevious: function stepToPrevious() {
            this.$parent.stepToPrevious();
        },
        stepToNext: function stepToNext() {
            this.$parent.stepToNext();
        },
        handleScroll: function handleScroll() {
            var ref = this.$refs["sp-modal-page-content-" + this.name];
            var scrollY = ref.scrollTop;
            var scrollTarget = 50;
            var target = 0.99;

            var percentage = scrollY / scrollTarget;
            var value = Math.max(0, Math.min(target, target * percentage));
            if (value <= 1) {
                this.borderTopOpacity = value;
            } else {
                this.borderTopOpacity = 1;
            }
        }
    }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "SpModalPageError",
    props: ["name"]
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpIconClose"
}); //
//
//
//
//
//
//
//

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpIconChevronDown"
}); //
//
//
//
//
//
//

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpDropdown",
    props: ["id", "align", "expand", "offsetX", "offsetY"],
    data: function data() {
        return {
            isMounted: false,
            closeHandler: null,
            active: false // moved from prop, may cause havoc
        };
    },

    computed: {
        nullStyle: function nullStyle() {
            if (!this.isMounted) return null;

            // Get positions for dropdown
            var clientPositionX = 0;
            var clientPositionY = 0;

            var _$refs = this.$refs,
                trigger = _$refs.trigger,
                content = _$refs.content;

            var triggerWidth = trigger.firstChild.offsetWidth;
            var triggerHeight = trigger.firstChild.offsetHeight;
            var contentWidth = content.clientWidth;
            var contentHeight = content.offsetHeight;

            // Get desired alignment for dropdown
            var align = (this.align ? this.align : "cursor-cursor").split("-", 2);
            var alignY = align[0];
            var alignX = align[1];

            var offsetX = this.offsetX ? this.offsetX : "0px";
            var offsetY = this.offsetY ? this.offsetY : "0px";

            var expand = (this.expand ? this.expand : "bottom-right").split("-", 2);
            var expandY = expand[0];
            var expandX = expand[1];

            // Apply positions for dropdown
            var alignTop = "";
            var alignLeft = "";
            var transformOrigin = "";
            // let transform = "";

            // alignment
            if (alignX === "cursor") {
                alignLeft = clientPositionX;
            }
            if (alignX === "left") {
                alignLeft = 0;
            }
            if (alignX === "right") {
                alignLeft = triggerWidth;
            }

            if (alignY === "cursor") {
                alignTop = clientPositionY;
            }
            if (alignY === "top") {
                alignTop = 0;
            }
            if (alignY === "bottom") {
                alignTop = triggerHeight;
            }

            // transform origin
            if (expandX === "left" && expandY === "top") {
                transformOrigin = "bottom right";
            } else if (expandX === "right" && expandY === "top") {
                transformOrigin = "bottom left";
            }
            if (expandX === "left" && expandY === "bottom") {
                transformOrigin = "top right";
            } else if (expandX === "right" && expandY === "bottom") {
                transformOrigin = "top left";
            }

            // offset
            if (expandX === "left") {
                alignLeft += -contentWidth;
                // transform = "translateX(-100px)";
            }
            if (expandY === "top") {
                alignTop += -contentHeight;
            }

            return "\n                top: " + ("calc(" + alignTop + "px + " + offsetY + ")") + ";\n                left: " + ("calc(" + alignLeft + "px + " + offsetX + ")") + ";\n                transform-origin: " + transformOrigin + ";\n                \n            ";
        },
        contentStyle: function contentStyle() {
            if (!this.isMounted) return null;

            // Get desired alignment for dropdown
            var expand = (this.expand ? this.expand : "bottom-right").split("-", 2);
            var expandY = expand[0];
            var expandX = expand[1];

            // Apply positions for dropdown
            var transform = "";

            // offset
            if (expandX === "left") {
                transform = "translateX(-100%)";
            }
            if (expandY === "top") {
                transform = "translateY(-100%)";
            }

            return "\n                transform: " + transform + ";\n                \n            ";
        }
    },
    mounted: function mounted() {
        this.isMounted = true;
    },

    methods: {
        toggle: function toggle(e) {
            var _this = this;

            // e.preventDefault();
            // e.stopPropagation();

            if (this.closeHandler) {
                document.removeEventListener("click", this.closeHandler);
                document.removeEventListener("touchstart", this.closeHandler);
                this.closeHandler = null;
            }
            if (this.active) {
                this.active = false;
                return;
            }

            this.active = true;

            // add Event Listeners
            document.addEventListener("click", this.closeHandler);
            document.addEventListener("touchstart", this.closeHandler);

            // Define Handler and cache it on the element
            var handler = function handler(he) {
                var isCloseTrigger = he.target.className.match(/\bsp-trigger-close\b/) != null;
                console.log(isCloseTrigger);
                if (isCloseTrigger || !_this.isChild(he.target, _this.$refs.content)) {
                    _this.active = false;
                    document.removeEventListener("click", _this.closeHandler);
                    document.removeEventListener("touchstart", _this.closeHandler);
                    _this.closeHandler = null;
                }
            };
            this.closeHandler = handler;

            // add Event Listeners
            setTimeout(function () {
                document.addEventListener("click", handler);
                document.addEventListener("touchstart", handler);
            }, 0);
        },
        isChild: function isChild(obj, parentObj) {
            while (obj != undefined && obj != null && obj.tagName.toUpperCase() != "BODY") {
                if (obj == parentObj) {
                    return true;
                }
                obj = obj.parentNode;
            }
            return false;
        }
    }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpLoadingDots"
}); //
//
//
//
//
//
//
//

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SpComponent = __webpack_require__(1);

var _SpComponent2 = _interopRequireDefault(_SpComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _SpComponent2.default({
    name: "SpLoadingSlider",
    props: {
        value: {
            default: function _default() {
                return 25;
            }
        }
    }
}); //
//
//
//
//
//
//
//

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _components = __webpack_require__(27);

var components = _interopRequireWildcard(_components);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spatial = function Spatial(Vue) {
    (0, _material2.default)(Vue);

    Object.values(components).forEach(function (component) {
        Vue.use(component);
    });
};

Spatial.version = "__VERSION__";

exports.default = Spatial;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (data) {
    var Instance = {};

    _vue2.default.util.defineReactive(Instance, "reactive", data);

    return Instance.reactive;
};

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SpLoading = exports.SpDropdown = exports.SpIcon = exports.SpModal = exports.SpRadio = exports.SpCheckbox = exports.SpTreemenu = exports.SpOverlay = exports.SpMobileMenu = exports.SpInput = exports.SpButton = undefined;

var _SpButton = __webpack_require__(28);

var _SpButton2 = _interopRequireDefault(_SpButton);

var _SpInput = __webpack_require__(33);

var _SpInput2 = _interopRequireDefault(_SpInput);

var _SpMobileMenu = __webpack_require__(46);

var _SpMobileMenu2 = _interopRequireDefault(_SpMobileMenu);

var _SpOverlay = __webpack_require__(50);

var _SpOverlay2 = _interopRequireDefault(_SpOverlay);

var _SpTreemenu = __webpack_require__(54);

var _SpTreemenu2 = _interopRequireDefault(_SpTreemenu);

var _SpCheckbox = __webpack_require__(61);

var _SpCheckbox2 = _interopRequireDefault(_SpCheckbox);

var _SpRadio = __webpack_require__(65);

var _SpRadio2 = _interopRequireDefault(_SpRadio);

var _SpModal = __webpack_require__(69);

var _SpModal2 = _interopRequireDefault(_SpModal);

var _SpIcon = __webpack_require__(79);

var _SpIcon2 = _interopRequireDefault(_SpIcon);

var _SpDropdown = __webpack_require__(85);

var _SpDropdown2 = _interopRequireDefault(_SpDropdown);

var _SpLoading = __webpack_require__(89);

var _SpLoading2 = _interopRequireDefault(_SpLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SpButton = _SpButton2.default;
exports.SpInput = _SpInput2.default;
exports.SpMobileMenu = _SpMobileMenu2.default;
exports.SpOverlay = _SpOverlay2.default;
exports.SpTreemenu = _SpTreemenu2.default;
exports.SpCheckbox = _SpCheckbox2.default;
exports.SpRadio = _SpRadio2.default;
exports.SpModal = _SpModal2.default;
exports.SpIcon = _SpIcon2.default;
exports.SpDropdown = _SpDropdown2.default;
exports.SpLoading = _SpLoading2.default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpButton = __webpack_require__(29);

var _SpButton2 = _interopRequireDefault(_SpButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpButton2.default.name, _SpButton2.default);
};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpButton_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpButton_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpButton_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpButton_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1177a2af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpButton_vue__ = __webpack_require__(32);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(30)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpButton_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1177a2af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpButton/SpButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1177a2af", Component.options)
  } else {
    hotAPI.reload("data-v-1177a2af", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.deepmerge = factory());
}(this, function () { 'use strict';

	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return target.propertyIsEnumerable(symbol)
			})
			: []
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	return deepmerge_1;

}));


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "sp-theme-default", on: { click: _vm.triggerClick } },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1177a2af", esExports)
  }
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpInputField = __webpack_require__(34);

var _SpInputField2 = _interopRequireDefault(_SpInputField);

var _SpInputText = __webpack_require__(37);

var _SpInputText2 = _interopRequireDefault(_SpInputText);

var _SpInputTextarea = __webpack_require__(40);

var _SpInputTextarea2 = _interopRequireDefault(_SpInputTextarea);

var _SpInputSelect = __webpack_require__(43);

var _SpInputSelect2 = _interopRequireDefault(_SpInputSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpInputField2.default.name, _SpInputField2.default);
    Vue.component(_SpInputText2.default.name, _SpInputText2.default);
    Vue.component(_SpInputTextarea2.default.name, _SpInputTextarea2.default);
    Vue.component(_SpInputSelect2.default.name, _SpInputSelect2.default);
}; // eslint-disable-next-line import/no-unresolved

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputField_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputField_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputField_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputField_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb625c82_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputField_vue__ = __webpack_require__(36);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(35)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputField_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb625c82_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpInput/SpInputField.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bb625c82", Component.options)
  } else {
    hotAPI.reload("data-v-bb625c82", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sp-input-field", attrs: { id: _vm.id } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("div", { staticClass: "sp-input-field-outline-idle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sp-input-field-outline-active" }),
      _vm._v(" "),
      _c("label", { staticClass: "active", attrs: { for: _vm.id } }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "sp-input-field-validation" }, [
        _vm._v(_vm._s(_vm.validationMessage))
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb625c82", esExports)
  }
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputText_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputText_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputText_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputText_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c17478_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputText_vue__ = __webpack_require__(39);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputText_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c17478_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpInput/SpInputText.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21c17478", Component.options)
  } else {
    hotAPI.reload("data-v-21c17478", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sp-input-field",
    {
      attrs: {
        id: _vm.id,
        label: _vm.label,
        validationMessage: _vm.validationMessage
      },
      on: {
        click: function($event) {
          return _vm.$refs.input.$el.focus()
        }
      }
    },
    [
      _vm.prefix
        ? _c(
            "p",
            {
              staticClass: "sp-input-prefix",
              on: {
                click: function($event) {
                  return _vm.$refs.input.focus()
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.prefix) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.buffer,
                expression: "buffer"
              }
            ],
            ref: "input",
            staticClass: "sp-input-text",
            class: [
              { valid: _vm.placeholder || _vm.prefix || !_vm.isNull },
              { "input-validation-error": !_vm.isValid }
            ],
            attrs: {
              placeholder: _vm.placeholder,
              maxlength: _vm.maxlength,
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.buffer)
                ? _vm._i(_vm.buffer, null) > -1
                : _vm.buffer
            },
            on: {
              input: function($event) {
                return _vm.updateValue($event.target.value)
              },
              blur: function($event) {
                return _vm.blur($event.target.value)
              },
              keydown: _vm.keyDown,
              keyup: _vm.keyUp,
              change: function($event) {
                var $$a = _vm.buffer,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.buffer = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.buffer = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.buffer = $$c
                }
              }
            }
          })
        : _vm.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.buffer,
                expression: "buffer"
              }
            ],
            ref: "input",
            staticClass: "sp-input-text",
            class: [
              { valid: _vm.placeholder || _vm.prefix || !_vm.isNull },
              { "input-validation-error": !_vm.isValid }
            ],
            attrs: {
              placeholder: _vm.placeholder,
              maxlength: _vm.maxlength,
              type: "radio"
            },
            domProps: { checked: _vm._q(_vm.buffer, null) },
            on: {
              input: function($event) {
                return _vm.updateValue($event.target.value)
              },
              blur: function($event) {
                return _vm.blur($event.target.value)
              },
              keydown: _vm.keyDown,
              keyup: _vm.keyUp,
              change: function($event) {
                _vm.buffer = null
              }
            }
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.buffer,
                expression: "buffer"
              }
            ],
            ref: "input",
            staticClass: "sp-input-text",
            class: [
              { valid: _vm.placeholder || _vm.prefix || !_vm.isNull },
              { "input-validation-error": !_vm.isValid }
            ],
            attrs: {
              placeholder: _vm.placeholder,
              maxlength: _vm.maxlength,
              type: _vm.type
            },
            domProps: { value: _vm.buffer },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.buffer = $event.target.value
                },
                function($event) {
                  return _vm.updateValue($event.target.value)
                }
              ],
              blur: function($event) {
                return _vm.blur($event.target.value)
              },
              keydown: _vm.keyDown,
              keyup: _vm.keyUp
            }
          }),
      _vm._v(" "),
      _vm.suffix
        ? _c(
            "p",
            {
              staticClass: "sp-input-suffix",
              on: {
                click: function($event) {
                  return _vm.$refs.input.focus()
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.suffix) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.required
        ? _c(
            "p",
            {
              staticClass: "sp-input-required",
              on: {
                click: function($event) {
                  return _vm.$refs.input.focus()
                }
              }
            },
            [_vm._v("\n        *\n    ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21c17478", esExports)
  }
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputTextarea_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputTextarea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputTextarea_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputTextarea_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputTextarea_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f55372f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputTextarea_vue__ = __webpack_require__(42);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(41)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputTextarea_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f55372f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpInput/SpInputTextarea.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f55372f6", Component.options)
  } else {
    hotAPI.reload("data-v-f55372f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sp-input-field", { attrs: { label: _vm.label } }, [
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.buffer,
          expression: "buffer"
        }
      ],
      ref: "textarea",
      staticClass: "sp-input-textarea",
      class: [
        { valid: !_vm.isNull },
        { "input-validation-error": !_vm.isValid }
      ],
      attrs: { id: _vm.id, placeholder: _vm.placeholder, type: "text" },
      domProps: { value: _vm.buffer },
      on: {
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.buffer = $event.target.value
          },
          function($event) {
            return _vm.updateValue($event.target.value)
          }
        ]
      }
    }),
    _vm._v(" "),
    _vm.autoheight
      ? _c("pre", { ref: "ghost", staticClass: "sp-input-textarea-ghosting" }, [
          _vm._v(_vm._s(_vm.buffer))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f55372f6", esExports)
  }
}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputSelect_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputSelect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputSelect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputSelect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2515e407_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputSelect_vue__ = __webpack_require__(45);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(44)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpInputSelect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2515e407_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpInputSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpInput/SpInputSelect.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2515e407", Component.options)
  } else {
    hotAPI.reload("data-v-2515e407", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sp-input-field",
    {
      staticClass: "sp-input-select",
      class: [{ active: _vm.active }],
      attrs: { id: _vm.id, label: _vm.label },
      on: { blur: _vm.blur }
    },
    [
      _c("input", {
        attrs: { id: "testHidden", type: "hidden" },
        domProps: { value: _vm.value }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.buffer,
            expression: "buffer"
          }
        ],
        ref: "input",
        staticClass: "sp-input-select-text",
        class: [
          { valid: !_vm.isNull },
          { "input-validation-error": !_vm.isValid },
          { "dissable-search": !_vm.search }
        ],
        attrs: {
          placeholder: _vm.placeholder,
          type: "text",
          maxlength: _vm.maxlength
        },
        domProps: { value: _vm.buffer },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.buffer = $event.target.value
            },
            function($event) {
              return _vm.updateValue($event.target.value)
            }
          ],
          click: _vm.toggle
        }
      }),
      _vm._v(" "),
      !_vm.search
        ? _c(
            "p",
            { staticClass: "sp-input-select-value", on: { click: _vm.toggle } },
            [_vm._v("\n        " + _vm._s(_vm.buffer) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("sp-icon-chevron-down"),
      _vm._v(" "),
      _c(
        "div",
        { ref: "dropdown", staticClass: "sp-input-select-dropdown sp-z-2" },
        _vm._l(_vm.matchedItems, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "sp-input-select-dropdown-item",
              on: {
                click: function($event) {
                  return _vm.selectItem(item.value)
                }
              }
            },
            [_vm._v("\n            " + _vm._s(item.header) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sp-select d-flex align-v-center noselect",
          class: [{ active: _vm.isActive }, { valid: _vm.value !== null }],
          staticStyle: { display: "none" },
          attrs: {
            id: _vm.id,
            "data-input": "testHidden",
            "data-align": "top"
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggle($event)
            }
          }
        },
        [
          _c("div", {
            staticClass: "sp-select-content d-flex align-v-center",
            domProps: { innerHTML: _vm._s(_vm.selectedHtml) }
          }),
          _vm._v(" "),
          _c("i", { staticClass: "mdi mdi-chevron-down" }),
          _vm._v(" "),
          _c("div", { staticClass: "sp-select-dropdown sp-z-2 noselect" }, [
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isActive,
                    expression: "isActive"
                  }
                ],
                staticClass: "sp-menu-items noselect",
                attrs: { id: "list" }
              },
              [_vm._t("default")],
              2
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2515e407", esExports)
  }
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpMobileMenu = __webpack_require__(47);

var _SpMobileMenu2 = _interopRequireDefault(_SpMobileMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpMobileMenu2.default.name, _SpMobileMenu2.default);
};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpMobileMenu_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpMobileMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpMobileMenu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpMobileMenu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpMobileMenu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063bb70f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpMobileMenu_vue__ = __webpack_require__(49);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpMobileMenu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063bb70f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpMobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpMobileMenu/SpMobileMenu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-063bb70f", Component.options)
  } else {
    hotAPI.reload("data-v-063bb70f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sp-mobile-menu sp-z-3",
      class: { enabled: _vm.enabled },
      on: {
        "!click": function($event) {
          return _vm.checkIfHide($event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-063bb70f", esExports)
  }
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpOverlay = __webpack_require__(51);

var _SpOverlay2 = _interopRequireDefault(_SpOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpOverlay2.default.name, _SpOverlay2.default);
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpOverlay_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpOverlay_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpOverlay_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpOverlay_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_105d4c92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpOverlay_vue__ = __webpack_require__(53);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(52)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpOverlay_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_105d4c92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpOverlay/SpOverlay.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-105d4c92", Component.options)
  } else {
    hotAPI.reload("data-v-105d4c92", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "sp-overlay",
    class: { enabled: _vm.enabled },
    on: { click: _vm.hide }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-105d4c92", esExports)
  }
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpTreemenu = __webpack_require__(55);

var _SpTreemenu2 = _interopRequireDefault(_SpTreemenu);

var _SpTreemenuItem = __webpack_require__(58);

var _SpTreemenuItem2 = _interopRequireDefault(_SpTreemenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpTreemenu2.default.name, _SpTreemenu2.default);
    Vue.component(_SpTreemenuItem2.default.name, _SpTreemenuItem2.default);
}; // eslint-disable-next-line import/no-unresolved

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenu_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dfe0c62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpTreemenu_vue__ = __webpack_require__(57);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(56)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dfe0c62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpTreemenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpTreemenu/SpTreemenu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8dfe0c62", Component.options)
  } else {
    hotAPI.reload("data-v-8dfe0c62", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "sp-treemenu", attrs: { id: _vm.id } },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dfe0c62", esExports)
  }
}

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenuItem_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenuItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenuItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenuItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenuItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_696ea402_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpTreemenuItem_vue__ = __webpack_require__(60);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(59)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpTreemenuItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_696ea402_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpTreemenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpTreemenu/SpTreemenuItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-696ea402", Component.options)
  } else {
    hotAPI.reload("data-v-696ea402", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "sp-treemenu-item-container",
      class: { expanded: _vm.expanded }
    },
    [
      _c(
        "div",
        { staticClass: "sp-treemenu-item", on: { click: _vm.select } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.hasSlotData
        ? _c("i", {
            staticClass: "expand mdi mdi-menu-left ml-auto",
            on: { click: _vm.toggleExpand }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { style: [_vm.expanded ? { height: "auto" } : {}] },
        [_vm._t("nested")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-696ea402", esExports)
  }
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpCheckbox = __webpack_require__(62);

var _SpCheckbox2 = _interopRequireDefault(_SpCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpCheckbox2.default.name, _SpCheckbox2.default);
};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpCheckbox_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpCheckbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpCheckbox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpCheckbox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpCheckbox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4297bbe2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpCheckbox_vue__ = __webpack_require__(64);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(63)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpCheckbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4297bbe2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpCheckbox/SpCheckbox.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4297bbe2", Component.options)
  } else {
    hotAPI.reload("data-v-4297bbe2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sp-input-field sp-input-field-checkbox" }, [
    _c("input", {
      attrs: { id: _vm._uid, type: "checkbox" },
      domProps: { checked: _vm.checked },
      on: { input: _vm.onInput }
    }),
    _vm._v(" "),
    _c("label", { attrs: { for: _vm._uid } }, [_vm._v(_vm._s(_vm.label))])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4297bbe2", esExports)
  }
}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpRadio = __webpack_require__(66);

var _SpRadio2 = _interopRequireDefault(_SpRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpRadio2.default.name, _SpRadio2.default);
};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpRadio_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpRadio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpRadio_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpRadio_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpRadio_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2743ce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpRadio_vue__ = __webpack_require__(68);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(67)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpRadio_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2743ce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpRadio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpRadio/SpRadio.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c2743ce6", Component.options)
  } else {
    hotAPI.reload("data-v-c2743ce6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sp-input-field sp-input-field-radio mt-2 p-1 nohighlight" },
    [
      _c("input", {
        key: _vm._uid,
        attrs: { id: _vm._uid, type: "radio", name: _vm.binding },
        domProps: { value: _vm.value },
        on: { input: _vm.onInput }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: _vm._uid } }, [_vm._v(_vm._s(_vm.label))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2743ce6", esExports)
  }
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpModal = __webpack_require__(70);

var _SpModal2 = _interopRequireDefault(_SpModal);

var _SpModalPage = __webpack_require__(73);

var _SpModalPage2 = _interopRequireDefault(_SpModalPage);

var _SpModalPageError = __webpack_require__(76);

var _SpModalPageError2 = _interopRequireDefault(_SpModalPageError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpModal2.default.name, _SpModal2.default);
    Vue.component(_SpModalPage2.default.name, _SpModalPage2.default);
    Vue.component(_SpModalPageError2.default.name, _SpModalPageError2.default);
};

// premade pages

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModal_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42208af1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpModal_vue__ = __webpack_require__(72);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(71)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42208af1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpModal/SpModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42208af1", Component.options)
  } else {
    hotAPI.reload("data-v-42208af1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sp-modal-container" }, [
    _c(
      "div",
      {
        staticClass: "sp-modal",
        class: [{ enabled: _vm.enabled }, { hide: _vm.hide }],
        style: "width:" + this.width + "; height:" + this.height
      },
      [
        _c(
          "div",
          { staticClass: "sp-modal-header" },
          [
            _vm._t("header", [
              _c("h4", [_vm._v(_vm._s(_vm.header))]),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "modal-close", on: { click: _vm.closeModal } },
                [
                  _c(
                    "sp-button",
                    {
                      directives: [
                        { name: "sp-ripple", rawName: "v-sp-ripple" }
                      ],
                      staticClass: "sp-button-text modal-close"
                    },
                    [_c("sp-icon-close")],
                    1
                  )
                ],
                1
              )
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sp-modal-content" },
          [_vm.error ? _c("sp-modal-page-error") : _vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42208af1", esExports)
  }
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPage_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35479da0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpModalPage_vue__ = __webpack_require__(75);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35479da0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpModalPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpModal/SpModalPage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35479da0", Component.options)
  } else {
    hotAPI.reload("data-v-35479da0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: _vm.name,
      staticClass: "sp-modal-page",
      class: { visible: _vm.visible }
    },
    [
      _c("div", {
        staticClass: "sp-modal-page-border-top sp-z-2",
        style: { opacity: _vm.borderTopOpacity }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "sp-modal-page-content-" + _vm.name,
          staticClass: "sp-modal-page-content",
          class: { "sp-modal-page-content-scroll": _vm.scroll }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sp-modal-page-footer" },
        [
          _vm._t("footer", [
            _c(
              "sp-button",
              {
                staticClass: "sp-button prev",
                on: { click: _vm.stepToPrevious }
              },
              [_vm._v("Previous")]
            ),
            _vm._v(" "),
            _c(
              "sp-button",
              { staticClass: "sp-button next", on: { click: _vm.stepToNext } },
              [_vm._v("Next")]
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35479da0", esExports)
  }
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPageError_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPageError_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPageError_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPageError_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPageError_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24561a78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpModalPageError_vue__ = __webpack_require__(78);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(77)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpModalPageError_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24561a78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpModalPageError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpModal/SpModalPageError.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24561a78", Component.options)
  } else {
    hotAPI.reload("data-v-24561a78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sp-modal-page-error" }, [
    _vm._v("\n    error\n")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24561a78", esExports)
  }
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpIconClose = __webpack_require__(80);

var _SpIconClose2 = _interopRequireDefault(_SpIconClose);

var _SpIconChevronDown = __webpack_require__(83);

var _SpIconChevronDown2 = _interopRequireDefault(_SpIconChevronDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpIconClose2.default.name, _SpIconClose2.default);
    Vue.component(_SpIconChevronDown2.default.name, _SpIconChevronDown2.default);
}; // eslint-disable-next-line import/no-unresolved

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconClose_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconClose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconClose_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconClose_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconClose_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daf9ece_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpIconClose_vue__ = __webpack_require__(82);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(81)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconClose_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daf9ece_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpIconClose_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpIcon/SpIconClose.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1daf9ece", Component.options)
  } else {
    hotAPI.reload("data-v-1daf9ece", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "sp-icon sp-icon-close",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1daf9ece", esExports)
  }
}

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconChevronDown_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconChevronDown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconChevronDown_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconChevronDown_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconChevronDown_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e96aede_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpIconChevronDown_vue__ = __webpack_require__(84);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpIconChevronDown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e96aede_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpIconChevronDown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpIcon/SpIconChevronDown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e96aede", Component.options)
  } else {
    hotAPI.reload("data-v-6e96aede", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "sp-icon sp-icon-chevron-down",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e96aede", esExports)
  }
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpDropdown = __webpack_require__(86);

var _SpDropdown2 = _interopRequireDefault(_SpDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpDropdown2.default.name, _SpDropdown2.default);
};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpDropdown_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpDropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpDropdown_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpDropdown_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpDropdown_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5703562_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpDropdown_vue__ = __webpack_require__(88);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(87)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpDropdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5703562_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpDropdown/SpDropdown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e5703562", Component.options)
  } else {
    hotAPI.reload("data-v-e5703562", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sp-dropdown", class: { active: _vm.active } },
    [
      _c(
        "div",
        {
          ref: "trigger",
          staticClass: "sp-dropdown-trigger",
          on: { click: _vm.toggle }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "null",
          staticClass: "sp-dropdown-null",
          class: { active: _vm.active },
          style: _vm.nullStyle
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active,
                  expression: "active"
                }
              ],
              ref: "content",
              staticClass: "sp-dropdown-content anim-fadeIn anim-duration-1",
              class: { active: _vm.active },
              style: _vm.contentStyle,
              attrs: { id: _vm.id }
            },
            [_vm._t("content")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5703562", esExports)
  }
}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _material = __webpack_require__(2);

var _material2 = _interopRequireDefault(_material);

var _SpLoadingDots = __webpack_require__(90);

var _SpLoadingDots2 = _interopRequireDefault(_SpLoadingDots);

var _SpLoadingSlider = __webpack_require__(93);

var _SpLoadingSlider2 = _interopRequireDefault(_SpLoadingSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
    (0, _material2.default)(Vue);
    Vue.component(_SpLoadingDots2.default.name, _SpLoadingDots2.default);
    Vue.component(_SpLoadingSlider2.default.name, _SpLoadingSlider2.default);
}; // eslint-disable-next-line import/no-unresolved

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingDots_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingDots_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingDots_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingDots_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingDots_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205bb079_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpLoadingDots_vue__ = __webpack_require__(92);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(91)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingDots_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205bb079_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpLoadingDots_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpLoading/SpLoadingDots.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-205bb079", Component.options)
  } else {
    hotAPI.reload("data-v-205bb079", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sp-loading-dots" }, [
      _c("div", { staticClass: "sp-loading-dot" }),
      _vm._v(" "),
      _c("div", { staticClass: "sp-loading-dot" }),
      _vm._v(" "),
      _c("div", { staticClass: "sp-loading-dot" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-205bb079", esExports)
  }
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingSlider_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingSlider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingSlider_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingSlider_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingSlider_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4decd060_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpLoadingSlider_vue__ = __webpack_require__(95);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(94)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpLoadingSlider_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4decd060_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpLoadingSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SpLoading/SpLoadingSlider.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4decd060", Component.options)
  } else {
    hotAPI.reload("data-v-4decd060", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sp-loading-slider" }, [
    _c("div", [_c("div", { style: "width:" + _vm.value + "%" })])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4decd060", esExports)
  }
}

/***/ })
/******/ ]);
});